import { i18n } from '@/boot/i18n';
import { version } from '@root/package.json';

export const MOBILE_BREAKPOINT = 1024;

export const DOWNLOAD_STATUS = {
  QUEUE: 1,
  PROCESSING: 2,
  COMPLETE: 3,
  ERROR: 4,
  CANCELED: 5,
};
export const RESOURCES = {
  INTERACTIONS: { key: 1, label: i18n.t('general.export.interactions'), name: 'interactions' },
  CUSTOMERS: { key: 2, label: i18n.t('general.export.customers'), name: 'customers' },
  DISTRIBUTIONS: { key: 3, label: i18n.t('general.export.distributions'), name: 'distributions' },
  CREDITS: { key: 4, label: i18n.t('general.export.credits'), name: 'credits' },
  LOGS: { key: 5, label: i18n.t('general.export.logs'), name: 'logs' },
  SURVEYS: { key: 6, label: i18n.t('general.export.surveys'), name: 'surveys' },
  ORGANIZATIONS: { key: 7, label: i18n.t('general.export.organizations'), name: 'organizations' },
  LOOPS: { key: 7, label: i18n.t('general.export.loops'), name: 'loops' },
};

export const INDICATOR_STATUS = {
  INCREASE: 1,
  STABLE: 2,
  DECREASE: 3,
};

export const USER_TREATMENT_OPTIONS = [
  { value: 0, label: i18n.t('consts.none') },
  { value: 1, label: i18n.t('consts.treatment.sr') },
  { value: 2, label: i18n.t('consts.treatment.srt') },
  { value: 3, label: i18n.t('consts.treatment.sra') },
  { value: 4, label: i18n.t('consts.treatment.srta') },
];

export const APP_VERSION = `cxm-app@${version}`;
